import React from 'react'

import './StopPanel.scss'

import iconStopHand from './i/stop-hand.svg'

const StopPanel = ({
    t,
    onBack,
    onQuit,
    isLoading = false,
    image = iconStopHand,
    headText = t('Are you sure that you want to quit?'),
    descriptionText = t('The changes you made will not be saved'),
    backText = t('Back'),
    quitText = t('Quit'),
    isShowQuit = true,
}) => (
    <div className="modal-stop">
        <div className="modal-stop__overlay" onClick={() => onBack()} />
        <div className="modal-stop__panel">
            <div className="note">
                {image && (
                    <div className="image">
                        <img src={image} alt="" />
                    </div>
                )}
                <div className="text">
                    <h4>{headText}</h4>
                    <p>{descriptionText}</p>
                </div>
            </div>
            <div className="buttons">
                <button className="button" data-variant="secondary" data-size="lg" onClick={() => onBack()}>
                    {backText}
                </button>
                {isShowQuit && (
                    <button
                        className="button"
                        data-variant="primary"
                        data-size="lg"
                        disabled={isLoading}
                        onClick={() => onQuit()}
                    >
                        {quitText}
                    </button>
                )}
            </div>
        </div>
    </div>
)

export default StopPanel
